var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("WalletAlerts", {
            staticClass: "mb-3",
            attrs: {
              context: _vm.walletAlertsContext,
              "ativos-carregando": !_vm.ativosDaCarteira.length
            },
            on: { action: _vm.onWalletAlertAction }
          }),
          _vm.showOrphanAssetsAlert
            ? _c("OrphanAssetsWarnings", {
                staticClass: "mb-3",
                attrs: { "wallet-analysis": _vm.walletAnalysis },
                on: { "link-asset": _vm.openOrphanAssetLink }
              })
            : _vm._e(),
          _c(
            "ConditionalTeleport",
            { attrs: { to: "page-header-actions", routes: _vm.moduleRoutes } },
            [
              _c("BasePageHeader", {
                scopedSlots: _vm._u([
                  {
                    key: "filter",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-center",
                            attrs: { "data-tour": "carteira-minha-filters" }
                          },
                          [
                            _c("WalletFilters", {
                              attrs: {
                                fields: _vm.walletFilters,
                                "enabled-field-keys": _vm.menuWalletFilterKeys,
                                disabled: _vm.filtersDisabled
                              },
                              on: { filter: _vm.reloadStatistics }
                            })
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "actions",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-center",
                            attrs: { "data-tour": "carteira-minha-actions" }
                          },
                          [
                            _vm.ehVisaoDeGrupo && _vm.acoesDoGrupo.length
                              ? _c("BaseSplitButton", {
                                  attrs: {
                                    label: _vm.rotuloAcaoDoGrupo,
                                    leading: _vm.iconeAcaoDoGrupo,
                                    items: _vm.acoesDoGrupo
                                  },
                                  on: {
                                    click: _vm.gerenciarMembrosDoGrupo,
                                    select: _vm.onAcaoDoGrupo
                                  }
                                })
                              : _vm.ehVisaoDeGrupo
                              ? _c(
                                  "BaseButton",
                                  {
                                    attrs: { primary: "" },
                                    on: { click: _vm.abrirNovoGrupo }
                                  },
                                  [_vm._v(" Adicionar grupo familiar ")]
                                )
                              : _vm.showWalletActions
                              ? _c("BaseSplitButton", {
                                  attrs: {
                                    label: "Cadastrar Ativo",
                                    leading: "plus",
                                    items: _vm.walletActions
                                  },
                                  on: {
                                    click: _vm.openNewAtivo,
                                    select: _vm.onWalletAction
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _vm.hasData
            ? _c("WalletEmptyState", {
                attrs: {
                  loading: _vm.loading,
                  "client-not-selected": _vm.clientNotSelected,
                  "clients-loading": _vm.loadingClients,
                  "has-selected-client": _vm.hasSelectedClient,
                  "has-access": _vm.hasAcess,
                  "has-clients": _vm.hasClients,
                  "has-assets": _vm.hasAssets,
                  "has-client": _vm.hasClient,
                  "is-client-user": _vm.usuarioAtual.IS_CLIENTE,
                  movements: _vm.movimentacoes,
                  investmentType: _vm.displayInvestmentTypeFilter,
                  "view-tipo": _vm.walletScope.viewTipo,
                  grupo: _vm.walletScope.grupo
                },
                on: {
                  "send-email": function($event) {
                    return _vm.enviarEmail(_vm.busLeft)
                  },
                  "collect-client-default": _vm.collectClientDefault,
                  "select-client": _vm.openSelectClient,
                  "open-new-client": _vm.openNewClient,
                  "new-group": _vm.abrirNovoGrupo,
                  "new-asset": _vm.openNewAtivo,
                  "import-assets": _vm.abrirImportarExtrato,
                  "new-movement": _vm.newMovement
                }
              })
            : _c(
                "v-row",
                [
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12", md: "12", lg: "12" } },
                      [
                        !_vm.ehVisaoDeGrupo
                          ? _c("InfoCarteira", {
                              attrs: {
                                idCliente: _vm.id_cliente,
                                loading: _vm.isLoadingInfoCard,
                                investmentType: _vm.displayInvestmentTypeFilter,
                                readonly: _vm.usuarioAtual.IS_CLIENTE,
                                clienteBenchmarkMeta: _vm.clienteBenchmarkMeta,
                                welcomeData: _vm.welcomeCardData
                              },
                              on: { "open-new-movement": _vm.openNewMovement }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12", md: "12", lg: "7" } },
                      [
                        _c("Evolucao", {
                          attrs: {
                            loading: _vm.isLoadingEvolution,
                            hasAssetsAutomatic: _vm.hasAssetsAutomatic,
                            dataRentabilidade: _vm.rentabilityChart,
                            dataPatrimonio: _vm.computedEvolucaoPatrimonial,
                            investmentType: _vm.displayInvestmentTypeFilter,
                            "benchmarks-selecionados":
                              _vm.benchmarksSelecionados,
                            benchmarks: _vm.BENCHMARKS,
                            "cliente-benchmark-meta": _vm.clienteBenchmarkMeta,
                            "available-benchmark-names":
                              _vm.availableBenchmarkNames,
                            "show-add-benchmark": !_vm.usuarioAtual.IS_CLIENTE,
                            "hide-benchmarks": !_vm.hasBenchmarks
                          },
                          on: {
                            "update:benchmarks-selecionados": function($event) {
                              _vm.benchmarksSelecionados = $event
                            },
                            "add-benchmark": _vm.openBenchmark,
                            reset: _vm.resetBenchmarks
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12", md: "12", lg: "5" } },
                      [
                        _c("MercadoIndicadores", {
                          attrs: {
                            loading: _vm.isLoadingMarketIndicators,
                            benchmarksStatistics:
                              _vm.walletPortfolioStatistics &&
                              _vm.walletPortfolioStatistics
                                .benchmarks_statistics,
                            brokerData: _vm.walletPortfolioStatistics
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12", md: "12", lg: "7" } },
                      [
                        _c("Estatisticas", {
                          attrs: {
                            loading: _vm.isLoadingStatisticsCard,
                            metricas: _vm.estatistica,
                            rentabilidade: _vm.statisticsRentability
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12", md: "12", lg: "5" } },
                      [
                        _c("Distribuicao", {
                          attrs: {
                            loading: _vm.isLoadingDistribution,
                            distribuicaoPor: "Instituição",
                            data: _vm.institutionDistributionChart,
                            investmentType: _vm.displayInvestmentTypeFilter
                          }
                        })
                      ],
                      1
                    ),
                    _vm.ehVisaoDeGrupo
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "8" } },
                          [
                            _c("GroupWalletTable", {
                              attrs: {
                                rows: _vm.linhasPorCarteira.rows,
                                totalRow: _vm.linhasPorCarteira.totalRow,
                                loading: _vm.loading,
                                totalMembersCount: _vm.membrosDoGrupo.length,
                                benchmarkLabel: _vm.benchmarkDoGrupo
                              },
                              on: {
                                "explain-total": _vm.abrirExplicacaoDoTotal
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.ehVisaoDeGrupo
                      ? _c(
                          "v-col",
                          { attrs: { cols: "12", lg: "4" } },
                          [
                            _c("GenericOverviewDonutChart", {
                              attrs: {
                                minHeight: 280,
                                title: "Distribuição por Conta",
                                chartData: _vm.distribuicaoPorConta,
                                baseKey:
                                  _vm.GROUP_ACCOUNT_DISTRIBUTION_BASE_KEY,
                                loading: _vm.loading,
                                useSum: ""
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12", md: "12", lg: "12" } },
                      [
                        _c("AlocacaoEstrategica", {
                          attrs: {
                            loading: _vm.isLoadingAllocationChart,
                            valuesChart: _vm.alocacaoChartValues,
                            optionsChat: _vm.alocacaoChartOpts,
                            investmentType: _vm.displayInvestmentTypeFilter,
                            colorsByLabel: _vm.allocationColorsByLabel,
                            suggestedValues: _vm.suggestedAllocations
                          },
                          on: {
                            "update:viewMode": _vm.handleAllocationViewMode
                          }
                        })
                      ],
                      1
                    ),
                    _vm.shouldShowAllocationDetails
                      ? _c(
                          "v-col",
                          {
                            attrs: { cols: "12", sm: "12", md: "12", lg: "12" }
                          },
                          [
                            _c("DetalhamentoAlocacaoEstrategica", {
                              attrs: {
                                loading: _vm.isLoadingAllocationDetails,
                                colorsByLabel: _vm.allocationColorsByLabel,
                                alocacaoClienteInvalida:
                                  _vm.alocacaoClienteInvalidaFromWallet,
                                perfil: _vm.perfilFromWallet,
                                statusBalanceamento:
                                  _vm.statusBalanceamentoFromWallet,
                                temFundoComposto:
                                  _vm.temFundoCompostoFromWallet,
                                fundoCompostoExpandido:
                                  _vm.fundoCompostoExpandido,
                                filteredClassesWithPerfil:
                                  _vm.filteredClassesWithPerfilFromWallet,
                                classesComComposicao:
                                  _vm.classesComComposicaoFromWallet,
                                alocationDataEstatistics:
                                  _vm.alocationDataEstatisticsFromWallet,
                                mapClassRent: _vm.mapClassRentFromWallet,
                                getClassVol: _vm.getClassVolFromWallet,
                                groupBy: _vm.modo_filtro_corretora,
                                resultFracoes: _vm.resultFracoesFromWallet,
                                resultFracoesClasse:
                                  _vm.resultFracoesClasseFromWallet,
                                mapperBenchmarks: _vm.mapper_benchmarks,
                                viewMode: _vm.viewMode,
                                fracoesAnbima: _vm.fracoesAnbima,
                                maxAnbimaPorClasse: _vm.maxAnbimaPorClasse,
                                statusDesenquadramento:
                                  _vm.statusDesenquadramento,
                                clienteSemPerfil: _vm.clienteSemPerfil,
                                podeDefinirPerfil: _vm.podeDefinirPerfil
                              },
                              on: {
                                "definir-perfil":
                                  _vm.abrirEdicaoDoPerfilDoCliente,
                                "change-view-mode": _vm.onChangeViewMode,
                                changeFundoCompostoExpandido: function($event) {
                                  _vm.fundoCompostoExpandido = $event
                                },
                                salvarFundoCompostoConfigLocal:
                                  _vm.salvarFundoCompostoConfigLocal
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12", md: "12", lg: "12" } },
                      [
                        _c("DetalhamentoCarteiraAtivos", {
                          attrs: {
                            "columns-config": _vm.colunasDaCarteira,
                            "sugestoes-pendentes-por-ativo":
                              _vm.sugestoesPendentesPorAtivo,
                            "sugestoes-por-movimentacao":
                              _vm.sugestoesPorMovimentacao,
                            "movimentacoes-das-sugestoes":
                              _vm.movimentacoesDasSugestoes,
                            "carregando-sugestoes": _vm.carregandoSugestoes,
                            loading: _vm.isLoadingAssetsDetails,
                            reloading: _vm.showAssetsReloadLoading,
                            carteira: _vm.carteiraFromWallet,
                            groupBy: _vm.modo_filtro_corretora,
                            groupLabelByKey: _vm.groupLabelByKey,
                            loadingRentAsset: false,
                            "allowed-actions": _vm.acoesPermitidasNaTabela,
                            readonly: _vm.tabelaDeAtivosSomenteLeitura,
                            statisticsAssets: _vm.statisticsAssetsFromWallet,
                            clienteAtual: _vm.clienteAtual,
                            ativosSelecionados: _vm.ids_ativos_selecionados,
                            modoFiltroCorretora: _vm.modo_filtro_corretora,
                            estatisticasClasse:
                              _vm.alocationDataEstatisticsFromWallet,
                            composicaoFundos: _vm.composicaoFundosFromWallet,
                            movimentacoes: _vm.movimentacoes,
                            alertMarcacaoMercadoRF: _vm.alertMarcacaoMercadoRF,
                            mapperBenchmarks: _vm.mapper_benchmarks,
                            filtroCorretora: _vm.filtro_corretora,
                            dataFim: _vm.dataFim,
                            benchmarks: _vm.BENCHMARKS,
                            investmentType: _vm.displayInvestmentTypeFilter,
                            "visible-columns": _vm.assetTableVisibleColumns,
                            carteirasRecomendadas:
                              _vm.carteirasRecomendadasCliente,
                            plTotal: _vm.walletPlTotal
                          },
                          on: {
                            "ativos-planos": _vm.onAtivosDaCarteira,
                            selecionarAtivosClasse: _vm.selecionarAtivosClasse,
                            openSaveBenchmark: _vm.openSaveBenchmark,
                            openNewAtivo: _vm.openNewAtivo,
                            aporteResgate: _vm.aporteResgate,
                            openVincular: _vm.openVincular,
                            openModalDelete: _vm.openModalDelete,
                            updateAtivosSelecionados: function($event) {
                              _vm.ativos_selecionados = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                ],
                2
              )
        ],
        1
      ),
      _c("ModalRemoverAtivo"),
      _c("ConsolidatorSelectClient"),
      _c("DetailsAsset", {
        attrs: {
          bus: _vm.bus,
          "bus-left": _vm.busLeft,
          "edit-ativo": _vm.openNewAtivo
        }
      }),
      _c("ResgateTotal", { attrs: { bus: _vm.busModal } }),
      _c("RemoverProduto"),
      _c("AcoesLote", {
        attrs: {
          acoes: _vm.acoes_lote_ativos,
          tipo: "ativos",
          tipoSingular: "ativo"
        },
        model: {
          value: _vm.ativos_selecionados,
          callback: function($$v) {
            _vm.ativos_selecionados = $$v
          },
          expression: "ativos_selecionados"
        }
      }),
      _c("ModalClientsCarteiraAdministrada"),
      _c("ModalAcoesLoteAtivos"),
      _vm._l(_vm.whatsNewSteps, function(step, i) {
        return _c("Tour", {
          key: "whatsnew-tour-" + i,
          attrs: {
            "steps-tour": _vm.whatsNewSteps,
            "current-step": _vm.currentTour,
            disable: _vm.currentTour !== i,
            "target-selector": _vm.whatsNewTargets[i]
          },
          on: { closeTour: _vm.closeTour, nextStep: _vm.nextTour }
        })
      }),
      !_vm.isTourActive
        ? _c("OptionsTourManual", { on: { tour: _vm.startTour } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }